module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contents"
  }, [_c('headerTop'), _vm._v(" "), _c('div', {
    staticClass: "swiperImg",
    style: ({
      backgroundImage: 'url(' + _vm.$index.addurl(_vm.img) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "center page-content",
    style: ({
      animation: _vm.animation
    })
  }, [_c('div', {
    staticClass: "headers"
  }, [_c('div', {
    ref: "type",
    staticClass: "type flexleft"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("类别")]), _vm._v(" "), _c('div', {
    class: _vm.typeStatus == 1 ? 'hidden' : ''
  }, [_c('div', {
    staticClass: "typeList flexleft"
  }, [_c('div', {
    class: _vm.typeCurrent == -1 ? 'childs' : 'child',
    on: {
      "click": _vm.typeAll
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.typeList), function(item, index) {
    return _c('div', {
      class: index == _vm.typeCurrent ? 'childs' : 'child',
      on: {
        "click": function($event) {
          return _vm.typeChange(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), (_vm.typeStatus == 1) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.typeStatus = 2
      }
    }
  }, [_vm._v("更多")]) : _vm._e(), _vm._v(" "), (_vm.typeStatus == 2) ? _c('div', {
    staticClass: "pack",
    on: {
      "click": function($event) {
        _vm.typeStatus = 1
      }
    }
  }, [_vm._v("收起")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "tag",
    staticClass: "type flexleft"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    class: _vm.tagStatus == 1 ? 'hidden' : ''
  }, [_c('div', {
    staticClass: "typeList flexleft"
  }, [_c('div', {
    class: _vm.tagCurrent == -1 ? 'childs' : 'child',
    on: {
      "click": _vm.tagAll
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.tagList), function(item, index) {
    return _c('div', {
      class: index == _vm.tagCurrent ? 'childs' : 'child',
      on: {
        "click": function($event) {
          return _vm.tagChange(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), (_vm.tagStatus == 1) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.tagStatus = 2
      }
    }
  }, [_vm._v("更多")]) : _vm._e(), _vm._v(" "), (_vm.tagStatus == 2) ? _c('div', {
    staticClass: "pack",
    on: {
      "click": function($event) {
        _vm.tagStatus = 1
      }
    }
  }, [_vm._v("收起")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "videoList flexleft"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "child flexbetween"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "endetime flexleft"
    }, [(item.endtime <= _vm.timestamp) ? _c('div', {
      staticClass: "colorLv"
    }) : _vm._e(), _vm._v(" "), (item.endtime > _vm.timestamp) ? _c('div', {
      staticClass: "colorRed"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.endtime * 1000 > _vm.timestamp && _vm.timestamp > item.starttime * 1000 ? '正在进行' : _vm.timestamp > item.endtime * 1000 ? '已结束' : '未开始') + " " + _vm._s(item.start) + "-" + _vm._s(item.end))])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.$index.addurl(item.thum),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "right_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "times flexleft"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.start) + "-" + _vm._s(item.end))]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.type == 1 ? '线上' : item.type == 2 ? '线下' : '线上+线下'))])]), _vm._v(" "), _c('div', {
      staticClass: "contentss"
    }, [_vm._v(_vm._s(item.info))]), _vm._v(" "), _c('div', {
      staticClass: "address flexleft"
    }, [_c('div', {
      staticClass: "addImg"
    }, [(item.type == 2) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/dingwei.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 1) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/diannao.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "txt flexleft"
    }, [(item.type == 2) ? _c('div', {
      staticClass: "addressTxt"
    }, [_vm._v("地址：" + _vm._s(item.offline_address))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flexright"
    }, [_c('div', {
      staticClass: "ljmore",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.todetail(item.id)
        }
      }
    }, [_vm._v("了解更多")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "hide-on-single-page": _vm.value,
      "current-page": _vm.currentPage,
      "page-size": 10,
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.addPage
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dc23eb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/joinActivity/joinActivity.vue
// module id = 1079
// module chunks = 1